module.exports = __webpack_public_path__ + "img/news9-5.17745abc.png";